import {EmailValidator} from './email.validator'
import {PhoneValidator} from './phone.validator'

/*
 Validators map (key is attribute value of 'type')
 For example: <input type='email' .../> will receive EmailValidator.validate validator
 */
export const TYPE_VALIDATORS = {
    email: EmailValidator.validate,
    phone: PhoneValidator.validate
};


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/type.validators.ts